import { GeneralActionTypes, GeneralState } from './types';
import { Action } from '../Actions';
import { CustomCursorStyle } from '../../data/enums/CustomCursorStyle';
import { ViewPointSettings } from '../../settings/ViewPointSettings';

const initialState: GeneralState = {
    windowSize: null,
    activePopupType: null,
    customCursorStyle: CustomCursorStyle.DEFAULT,
    activeContext: null,
    preventCustomCursor: false,
    imageDragMode: true,
    crossHairVisible: false,
    enablePerClassColoration: true,
    aiMode: true,
    projectData: {
        type: null,
        id: null,
        name: 'my-project-name',
    },
    zoom: ViewPointSettings.MIN_ZOOM,
    hotKeys: [],
    brightness: 1,
    contrast: 1,
    gamma: 1,
    grayscale: 0,
    taskType: 'ALL',

    aiAssist: {
        mode: '',
        status: null,
        openForm: false,
        showButtons: false,
        models: [],
    },

    inlineLabelPicker: {
        open: false,
        clientX: null,
        clientY: null,
        shapeId: null,
        shapeType: null,
    },
};

export function generalReducer(
    state = initialState,
    action: GeneralActionTypes
): GeneralState {
    switch (action.type) {
        case Action.UPDATE_WINDOW_SIZE: {
            return {
                ...state,
                windowSize: action.payload.windowSize
            }
        }
        case Action.UPDATE_ACTIVE_POPUP_TYPE: {
            return {
                ...state,
                activePopupType: action.payload.activePopupType
            }
        }
        case Action.UPDATE_CUSTOM_CURSOR_STYLE: {
            return {
                ...state,
                customCursorStyle: action.payload.customCursorStyle
            }
        }
        case Action.UPDATE_CONTEXT: {
            return {
                ...state,
                activeContext: action.payload.activeContext
            }
        }
        case Action.UPDATE_PREVENT_CUSTOM_CURSOR_STATUS: {
            return {
                ...state,
                preventCustomCursor: action.payload.preventCustomCursor
            }
        }
        case Action.UPDATE_IMAGE_DRAG_MODE_STATUS: {
            return {
                ...state,
                imageDragMode: action.payload.imageDragMode
            }
        }
        case Action.UPDATE_AI_MODE_STATUS: {
            return {
                ...state,
                aiMode: action.payload.aiMode
            }
        }
        case Action.UPDATE_CROSS_HAIR_VISIBLE_STATUS: {
            return {
                ...state,
                crossHairVisible: action.payload.crossHairVisible
            }
        }
        case Action.UPDATE_PROJECT_DATA: {
            return {
                ...state,
                projectData: action.payload.projectData
            }
        }
        case Action.UPDATE_ZOOM: {
            return {
                ...state,
                zoom: action.payload.zoom
            }
        }
        case Action.UPDATE_HOTKEYS: {
            return {
                ...state,
                hotKeys: action.payload.hotKeys
            }
        }
        case Action.UPDATE_ENABLE_PER_CLASS_COLORATION_STATUS: {
            return {
                ...state,
                enablePerClassColoration: action.payload.enablePerClassColoration
            }
        }
        case Action.UPDATE_BRIGHTNESS: {
            return {
                ...state,
                brightness: action.payload
            }
        }
        case Action.UPDATE_CONTRAST: {
            return {
                ...state,
                contrast: action.payload
            }
        }
        case Action.UPDATE_GAMMA: {
            return {
                ...state,
                gamma: action.payload
            }
        }

        case Action.UPDATE_GRAYSCALE: {
            return {
                ...state,
                grayscale: action.payload,
            };
        }

        case Action.UPDATE_TASK_TYPE: {
            return {
                ...state,
                taskType: action.payload,
            };
        }

        case Action.UPDATE_AI_ASSIST_MODE:
            return {
                ...state,
                aiAssist: {
                    ...state.aiAssist,
                    mode: action.payload,
                },
            };
        case Action.UPDATE_AI_ASSIST_STATUS:
            return {
                ...state,
                aiAssist: {
                    ...state.aiAssist,
                    status: action.payload,
                },
            };
        case Action.TOGGLE_AI_ASSIST_FORM:
            return {
                ...state,
                aiAssist: {
                    ...state.aiAssist,
                    openForm: action.payload,
                },
            };
        case Action.TOGGLE_AI_ASSIST_BUTTONS:
            return {
                ...state,
                aiAssist: {
                    ...state.aiAssist,
                    showButtons: action.payload,
                },
            };
        case Action.UPDATE_AI_ASSIST_MODELS:
            return {
                ...state,
                aiAssist: {
                    ...state.aiAssist,
                    models: action.payload,
                },
            };

        case Action.UPDATE_INLINE_LABEL_PICKER:
            return {
                ...state,
                inlineLabelPicker: action.payload,
            };

        default:
            return state;
    }
}
